import { Injectable } from 'angular-ts-decorators';

import { Language } from '@shared/app/scripts/services/language';

export interface IUpdate {
  title: string;
  body: { html: string };
}

/**
 * Service to query data from GraphCMS
 */
@Injectable('updates')
export class Updates {
  constructor(
    private $http: ng.IHttpService,
    private language: Language,
  ) {
    'ngInject';
  }

  /**
   * Fetches all updates from the CMS.
   * @returns
   * Resolves with data available on CMS.
   */
  getAll(): ng.IPromise<IUpdate[]> {
    let language = 'en';

    if (this.language.current === 'nl-nl') {
      language = 'nl';
    }

    return this.$http
      .get(
        'https://api-eu-central-1.graphcms.com/v2/cl5b4132q04j101unbwbcgh12/master?query=' +
          `{
  updates (locales: [${language}]) {
    title,
    body { html }
  }
}`,
      )
      .then((response: any) => {
        return response.data?.data?.updates;
      });
  }
}
